import type { ReleaseTypeInternal } from '@gonfalon/openapi/types';
import { getAutomatedReleasesQuery } from '@gonfalon/rest-api/queries/automatedReleases';
import { useQuery } from '@tanstack/react-query';

interface ReleasePhasesQueryParams {
  filter?: {
    environmentKey?: string;
  };
}

/**
 * Lists a flag's automated releases of one kind, optionally scoped to an environment.
 *
 * `data.items` are `ReleasePhaseInternal[]`.
 */
export function useReleasePhases(
  params: {
    projectKey: string;
    flagKey: string;
    kind: ReleaseTypeInternal;
    query?: ReleasePhasesQueryParams;
  },
  options: { enabled?: boolean } = {},
) {
  const callerEnabled = options.enabled !== false;

  const filterParts = [`kind:${params.kind}`];
  if (params.query?.filter?.environmentKey) {
    filterParts.push(`environmentKey:${params.query.filter.environmentKey}`);
  }

  const consolidatedResult = useQuery({
    ...getAutomatedReleasesQuery({
      projectKey: params.projectKey,
      flagKey: params.flagKey,
      query: { filter: filterParts.join(',') },
    }),
    enabled: callerEnabled,
  });

  return consolidatedResult;
}
